import { render, staticRenderFns } from "./FileDragDropArea.vue?vue&type=template&id=81556372&"
import script from "./FileDragDropArea.vue?vue&type=script&lang=js&"
export * from "./FileDragDropArea.vue?vue&type=script&lang=js&"
import style0 from "./FileDragDropArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports